import { useConfig } from '@/helpers/config'

export function useImage(filename) {
    const config = useConfig()
    return ( ( config.MEDIA_URL ) ? config.MEDIA_URL : '/wp-content/plugins/myAdelya/images/' ) + filename
}

export function useLink(url) {
    return ( url ) ? url.replace('&amp;', '&') : null
}